import { IconArrowRightDefault } from '@mc/design-system'

import classes from './Fab.module.scss'
import { trackConciergeClicked } from '../events'

export const OptionPill = ({
  question,
  onClick,
}: {
  question: string
  onClick: () => void
}) => {
  const handleClick = () => {
    trackConciergeClicked({ level: 'primary', action: question })
    onClick()
  }

  return (
    <button className='d-flex mc-clickable' onClick={handleClick}>
      <div
        className={`d-flex align-items-center mc-px-3 mc-py-2 mc-corners--lg mc-mb-2 ${classes.Pill}`}
      >
        <p className='mc-text-small'>{question}</p>
        <IconArrowRightDefault className='mc-ml-2' size='sm' />
      </div>
    </button>
  )
}
